import React, { useState } from "react";
import Header from "../components/Header";
import SideBar from "../components/SideBar";
import { Outlet } from "react-router-dom";
import Dashboard from "../pages/Dashboard";

const RootLayout = () => {
  const [open, setOpen] = useState(false);
  const openSideBar = () => {
    setOpen(!open);
  };
  return (
    <div className={open ? "CloseMenu" : ""}>
      <Header />
      <div>
        <SideBar openSideBar={openSideBar} open={open} />
        <main style={{ flexGrow: 1 }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default RootLayout;
